import React, { useEffect, useState } from 'react';
import TimeDifference from '../../../common/TimeDifference';
function Notifications() {
    const [notifications, setNotifications] = useState([]);

    useEffect(() => {
        //addFakeNotification();
      // Retrieve the notifications from localStorage
      const savedNotifications = JSON.parse(localStorage.getItem('notifications')) 
      if (savedNotifications) {
         // Sort notifications with latest on top
            const sortedNotifications = savedNotifications.sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));
            setNotifications(sortedNotifications);
      }
    }, []);

    const addFakeNotification = () => {
        const newNotification = {
          message: 'You have a new appointment request',
          timestamp: new Date().toISOString(),
          customer: '0000000000000',
          clinicId: 5,
          business:'0000000000',
        };
        const updatedNotifications = [newNotification, ...notifications];
        setNotifications(updatedNotifications);
        localStorage.setItem('notifications', JSON.stringify(updatedNotifications));
      };

  return (
   <>
    <div className='container'>
        <div className="row mb-4">
            <div className="col-12">
                <div className="d-flex justify-content-between mt-5">
                    <h1> <i className="bi bi-bell fs-1"></i> Past Notifications </h1>
                </div>
            </div>
        </div>
        <hr />
        <div className="row">
            <div className="col-12">
                <p className="text-muted">Here are the past notifications you have received.</p>
                {notifications.length === 0 ? (
                            <p>No notifications available.</p>
                        ) : (
                            <ul className="list-group">
                            {notifications.map((notification, index) => (
                                <li key={index} className="list-group-item d-flex justify-content-between align-items-start">
                                <div>
                                    <h6>{notification.message && notification.message}</h6>
                                    <p className="text-muted mb-2">{new Date(notification.timestamp).toLocaleString()}</p>
                                   
                                </div>
                                <button 
                                    className="btn btn-primary"
                                  
                                >
                                   <i className="bi bi-chat-square-text"></i> Send a quick reply
                                </button>
                                </li>
                            ))}
                            </ul>
                        )}
                <ul className='list-group'>
                        {notifications.length > 0 ? (
                        notifications.map((notification, index) => {
                          
                            //console.log(dtstring);
                            return (
                            <li className='list-group-item' key={index}>
                            <strong><TimeDifference dateString={notification.timestamp}/> : </strong> {notification.message}
                            </li>
                        )})
                        ) : (
                        <li>No notifications yet</li>
                        )}
                 </ul>
            </div>
        </div>
     
    
    </div>
   </>
  )
}

export default Notifications